"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reduxForm = require("redux-form");

var _Component = _interopRequireDefault(require("./Component"));

var _default = (0, _reduxForm.reduxForm)({
  form: 'paging-form',
  enableReinitialize: true
})(_Component["default"]);

exports["default"] = _default;